import React, { useState } from "react";
import { Minus, Plus } from "lucide-react";

const faqs = [
  {
    id: 1,
    question: "How do I place an order?",
    answer:
      "Browse the menu, add your favorite dishes to the cart, choose your delivery or pickup option, and complete your payment. You'll receive real time updates until your order arrives.",
  },
  {
    id: 2,
    question: "What payment methods do you accept?",
    answer:
      "We accept UPI, debit cards, credit cards, net banking, digital wallets, and cash on delivery where available.",
  },
  {
    id: 3,
    question: "What should I do if my order is delayed or incorrect?",
    answer:
      "Open your order details and contact our support team. We will check the order status and help resolve the issue as quickly as possible.",
  },
  {
    id: 4,
    question: "Can I customize my order?",
    answer:
      "Yes, available customization options will appear on the item page. You can select add-ons, remove ingredients, or add preparation notes.",
  },
  {
    id: 5,
    question: "How long does delivery take?",
    answer:
      "Delivery time depends on your location, restaurant preparation time, and traffic conditions. The estimated delivery time is shown before checkout.",
  },
  {
    id: 6,
    question: "Can I schedule an order in advance?",
    answer:
      "Yes, restaurants that support scheduled orders allow you to select a preferred delivery date and time during checkout.",
  },
];

export default function FAQSection() {
  const [activeFaq, setActiveFaq] = useState(1);

  const handleToggle = (faqId) => {
    setActiveFaq((previousId) => (previousId === faqId ? null : faqId));
  };

  return (
    <section className="w-full bg-blue-50 px-4 py-20 sm:px-5 sm:py-20 md:px-8 md:py-24">
      <div className="mx-auto w-full max-w-[1110px]">
        <h1 className="mb-6 text-center text-2xl font-semibold text-[#1f2937] sm:text-3xl md:mb-8 md:text-4xl">
          FAQ
        </h1>

        <div className="space-y-3 sm:space-y-3 md:space-y-4">
          {faqs.map((faq) => {
            const isActive = activeFaq === faq.id;

            return (
              <article
                key={faq.id}
                className={`overflow-hidden rounded-2xl border transition-all duration-300 ${
                  isActive
                    ? "border-gray-100 bg-white"
                    : "border-gray-300 bg-gray-100"
                }`}
              >
                <button
                  type="button"
                  onClick={() => handleToggle(faq.id)}
                  aria-expanded={isActive}
                  className={`grid w-full grid-cols-[1fr_auto] gap-4 px-5 py-5 text-left sm:px-6 sm:py-6 md:px-8 ${
                    isActive ? "items-start" : "items-center"
                  }`}
                >
                  <div className="col-span-2 grid grid-cols-[1fr_auto] items-center">
                    {/* Question */}
                    <h3 className="max-w-[320px] text-base font-semibold leading-6 text-gray-700 sm:max-w-none sm:text-lg sm:leading-7 md:text-[22px]">
                      {faq.question}
                    </h3>

                    {/* Icon */}
                    <span
                      className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full border transition-all duration-300 sm:h-12 sm:w-12 md:h-[44px] md:w-[44px] ${
                        isActive ? "-mt-1" : "self-center"
                      } ${
                        isActive
                          ? "border-[#dddddd] bg-[#f3f3f3] text-[#202020]"
                          : "border-[#242424] bg-[#202020] text-white"
                      }`}
                    >
                      {isActive ? (
                        <Minus
                          size={18}
                          strokeWidth={1.8}
                          className="sm:w-5 sm:h-5 md:w-[22px] md:h-[22px]"
                        />
                      ) : (
                        <Plus
                          size={18}
                          strokeWidth={1.8}
                          className="sm:w-5 sm:h-5 md:w-[22px] md:h-[22px]"
                        />
                      )}
                    </span>

                    {/* Answer */}
                    <div
                      className={`col-span-2 grid transition-all duration-300 ease-in-out ${
                        isActive
                          ? "grid-rows-[1fr] opacity-100"
                          : "grid-rows-[0fr] opacity-0"
                      }`}
                    >
                      <div className="overflow-hidden">
                        <p className="max-w-[1000px] text-sm leading-6 text-gray-600 sm:text-[15px] md:text-[18px] md:leading-7">
                          {faq.answer}
                        </p>
                      </div>
                    </div>
                  </div>
                </button>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
